import Vue from 'vue'
import Vuex from 'vuex'
import axios from '../axios'
import profileDefault from '@/assets/user_default.png'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        loading: false,
        loadingBounce: null,
        errorModalShow: false,
        errorModalMsg: '',
        successModalShow: false,
        successModalMsg: '',
        cameraService: {
            loading: false,
            status: null
        },
        branches: [],
        currentBranchId: null,
        companyProfileImg: '',
        permissions: [],
        userName: null,
        userImage: null
    },
    getters: {
        cameraServiceStatus: (state) => {
            const status = state.cameraService.status
            let v = 'on'
            if (status === false) {
                v = 'off'
            } else if (status === null) {
                v = 'none'
            }
            return v
        },
        getIcon: (state) => (name) => state.webIcons[name],
        getCurrentBranch: () => localStorage.getItem('currentBranch')
    },
    mutations: {
        setLoading (state, payload) {
            if (state.loadingBounce) {
                clearTimeout(state.loadingBounce)
            }

            if (payload) {
                state.loading = payload
            } else {
                state.loadingBounce = setTimeout(() => {
                    state.loading = payload
                }, 200)
            }
        },
        setErrorModalShow (state, payload) {
            state.errorModalShow = payload
        },
        setErrorModalMsg (state, payload) {
            state.errorModalMsg = payload
        },
        setCameraSerivceLoading (state, payload) {
            state.cameraService.loading = payload
        },
        setCameraSerivceStatus (state, payload) {
            if (![true, false, null].includes(payload)) {
                throw new Error(`State '${payload}' does not exist`)
            }
            state.cameraService.status = payload
        },
        setSuccessModalShow (state, payload) {
            state.successModalShow = payload
        },
        setSuccessModalMsg (state, payload) {
            state.successModalMsg = payload
        },
        setBranches (state, payload) {
            if (localStorage.getItem('currentBranch') && localStorage.getItem('currentBranch') !== 'null') {
                for (let i = 0; i < payload.length; i++) {
                    if (payload[i].id === localStorage.getItem('currentBranchId')) {
                        localStorage.setItem('currentBranch', payload[i])
                        localStorage.setItem('currentBranchId', payload[i].id)
                    }
                }
            } else if (payload.length > 0) {
                localStorage.setItem('currentBranch', payload[0])
                localStorage.setItem('currentBranchId', payload[0].id)
            }
            state.currentBranchId = localStorage.getItem('currentBranchId')
            state.branches = payload
        },
        setCurrentBranch (state, payload) {
            localStorage.setItem('currentBranch', payload)
            localStorage.setItem('currentBranchId', payload.id)
            state.currentBranchId = localStorage.getItem('currentBranchId')
        },

        setCompanyProfileImg (state, payload) {
            state.companyProfileImg = payload
        },

        setPermissions (state, payload) {
            state.permissions = payload
        },

        clearBranch (state) {
            state.branches = []
            state.currentBranchId = null
            localStorage.setItem('currentBranch', null)
            localStorage.setItem('currentBranchId', null)
        },

        setUserProfile (state, payload) {
            state.userName = payload.name
            state.userImage = payload.image
        }
    },
    actions: {
        setLoading ({ commit }, payload) {
            commit('setLoading', payload)
        },
        setErrorModalShow ({ commit }, payload) {
            commit('setErrorModalShow', payload)
        },
        setErrorModalMsg ({ commit }, payload) {
            commit('setErrorModalMsg', payload)
        },
        setSuccessModalShow ({ commit }, payload) {
            commit('setSuccessModalShow', payload)
        },
        setSuccessModalMsg ({ commit }, payload) {
            commit('setSuccessModalMsg', payload)
        },
        setCurrentBranch ({ commit }, payload) {
            commit('setCurrentBranch', payload)
        },
        async getBranches ({ commit }) {
            const res = await axios.get('branch/getAll')
            if (res && res.data && res.data.status === 'ok') {
                commit('setBranches', res.data.data)
            }
        },
        async getCompanyProfileImg ({ commit }) {
            const res = await axios.get('company/image/get')
            if (res && res.data && res.data.status === 'ok') {
                commit('setCompanyProfileImg', res.data.company)
            }
        },
        async getUserProfile ({ commit }) {
            const res = await axios.get('user/user-profile')

            if (res && res.data && res.data.status === 'ok') {
                const response = res.data.data
                const payload = {
                    name: null,
                    image: null
                }
                payload.name = `${response.first_name} ${response.last_name}`
                // set default image for empty f_path
                if (!response.userImage) {
                    payload.image = profileDefault
                } else {
                    payload.image = response.userImage
                }

                commit('setUserProfile', payload)
            }
        },
        async getPermissions ({ commit }) {
            const res = await axios.get('permission/get')
            if (res && res.data && res.data.status === 'ok') {
                const permissionList = res.data.data.permissions.map(permission => permission.name)
                commit('setPermissions', permissionList)
            }
        },
        changeCompanyProfileImg ({ commit }, payload) {
            commit('setCompanyProfileImg', payload)
        },
        clearBranch ({ commit }) {
            commit('clearBranch')
        }
    },
    modules: {
    }
})
